import { generatePath } from 'react-router-dom'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { AffiliateClientOverviewKey } from 'api/Affiliate/AffiliateDto'
import { Link } from 'components/Link'
import { formatLocalDateUTC } from 'utils/date'
import { links } from 'utils/featureToggles'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const affiliateClientsColumns: GridColumn[] = [
  {
    title: 'Name',
    field: AffiliateClientOverviewKey.name,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem?.name) {
        return <td />
      }

      return (
        <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
          <Link
            to={{
              pathname: generatePath(links.recordsClients.detailsUrl as string, {
                id: props.dataItem.id,
                slug: 'details',
              }),
            }}
          >
            {props.dataItem.name}
          </Link>
        </td>
      )
    },
    show: true,
  },
  {
    title: 'Country',
    field: AffiliateClientOverviewKey.country,
    show: true,
  },

  {
    title: 'Assigned at',
    field: AffiliateClientOverviewKey.assignedAt,
    cell: (props: GridCellProps): JSX.Element => {
      const formattedDate = formatLocalDateUTC(props.dataItem.assignedAt, true)
      return <td>{formattedDate}</td>
    },
    show: true,
  },
]
